import FlightItem from './FlightItem'

export default FlightItem
